import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RegenerateGenerativeTaskMutationVariables = Types.Exact<{
  data: Types.RegenerateGenerativeTaskInput;
}>;


export type RegenerateGenerativeTaskMutation = { regenerateGenerativeTask?: { generativeTask?: { id: string, error?: { errorCode: Types.GenerativeTaskErrorCodeEnum, message?: string | null } | null } | null } | null };


export const RegenerateGenerativeTaskDocument = /*#__PURE__*/ gql`
    mutation RegenerateGenerativeTask($data: RegenerateGenerativeTaskInput!) {
  regenerateGenerativeTask(data: $data) {
    generativeTask {
      id
      error {
        errorCode
        message
      }
    }
  }
}
    `;

export function useRegenerateGenerativeTaskMutation() {
  return Urql.useMutation<RegenerateGenerativeTaskMutation, RegenerateGenerativeTaskMutationVariables>(RegenerateGenerativeTaskDocument);
};